import React, { useState, useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { BaseTableRQ } from 'components/common/models/BaseClass';
import { search as searchSkillMatrix } from 'services/skill-matric-services/smSkillMatrixService';
import PropTypes from 'prop-types';
import SkillMatrixTable from './SkillMatrixTable';
import { getMaxtrixUsers } from 'services/userServices';
import SkillMatrixTableHeader from './SkillMatrixTableHeader';

const RunningSkillMatrix = () => {
  const defaultRQ = { ...new BaseTableRQ(1, 2147483647)};
  const [ogiginSkillMatrix, setOginginSkillMatrixs] = useState([]);
  const [skillMatrixs, setSkillMatrixs] = useState([]);
  const [isFilter, setIsFilter] = useState(false);
  const [searchUIParam, setSearchUIParam] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setIsFilter(false);
  }, []);

  const searchUI = ({ keyword, department }) => {
    let searchData = ogiginSkillMatrix;
    if (keyword) {
      searchData = searchData.filter(i =>
        i.login?.toLowerCase().includes(keyword.toLowerCase())
      );
    }
    if (department) {
      searchData = searchData.filter(
        i => i.departmentId?.toString() == department.id?.toString()
      );
    }

    setSkillMatrixs(searchData);
  };

  useEffect(() => {
    loadSkillMatrix(defaultRQ);
  }, []);

  const loadSkillMatrix = async pagingRq => {
    setLoading(true);
    const res = await searchSkillMatrix(pagingRq);
    const usersRes = await getMaxtrixUsers();

    const itemsByTrainee = new Map();
    res.items.forEach(i => {
      const key = i.trainee?.toString();
      const list = itemsByTrainee.get(key);
      if (list) list.push(i);
      else itemsByTrainee.set(key, [i]);
    });

    const data = usersRes.map(u => {
      let rs = { ...u, trainee: u.userId };
      const items = itemsByTrainee.get(u.userId?.toString()) || [];
      items.forEach(x => {
        rs[x.areaId?.toString()] = x.level;
        rs[x.areaId?.toString() + "_status"] = x.status;
        rs[x.areaId?.toString() + "_source"] = x.source;
      });
      return rs;
    });

    setOginginSkillMatrixs(data);
    setSkillMatrixs(data);
    setLoading(false);
  };

  return (
    <Card>
      <Row style={{ padding: '10px' }}>
        <SkillMatrixTableHeader
          handleChange={(key, value) => {
            console.log(key, value);
            const uiParam = { ...searchUIParam, [key]: value };
            console.log(uiParam);
            setSearchUIParam(uiParam);
            searchUI(uiParam);
          }}
          style={{ padding: '10px' }}
        />
        <Col lg={isFilter ? 9 : 12}>
          <SkillMatrixTable data={skillMatrixs} loading={loading} />
        </Col>
      </Row>
    </Card>
  );
};

RunningSkillMatrix.propTypes = {
  meetingId: PropTypes.string
};

export default RunningSkillMatrix;
